export function getPricingRange(products) {
    return products.reduce((acc, curr) => {
        var _a, _b, _c, _d, _e;
        const currPrice = (_a = curr.salesPrice) === null || _a === void 0 ? void 0 : _a.includingVat;
        if (currPrice === undefined)
            return acc;
        if (!acc.lowestProduct ||
            ((_c = (_b = acc.lowestProduct.salesPrice) === null || _b === void 0 ? void 0 : _b.includingVat) !== null && _c !== void 0 ? _c : Infinity) > currPrice) {
            acc.lowestProduct = curr;
        }
        if (!acc.highestProduct ||
            ((_e = (_d = acc.highestProduct.salesPrice) === null || _d === void 0 ? void 0 : _d.includingVat) !== null && _e !== void 0 ? _e : -Infinity) < currPrice) {
            acc.highestProduct = curr;
        }
        return acc;
    }, { lowestProduct: null, highestProduct: null });
}
//# sourceMappingURL=getPriceRange.js.map